(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-profile/assets/javascripts/behaviors/component-loader-promise.js') >= 0) return;  svs.modules.push('/modules/player-profile/assets/javascripts/behaviors/component-loader-promise.js');

'use strict';

svs.player_profile.behaviors.ComponentLoaderPromise = Marionette.Behavior.extend({
  ui: {
    loaderContainer: '.js-profile-loader-container'
  },
  onAttach() {
    const loader = new svs.ui.Loader(this.ui.loaderContainer);
    const containerRegion = this.view.getRegion('containerRegion');
    loader.show(300, 'inverted');
    if (containerRegion.currentView) {
      this.removeLoader(containerRegion, loader);
    } else {
      this.listenTo(containerRegion, 'show', () => this.removeLoader(containerRegion, loader));
    }
  },
  removeLoader(region, loader) {
    region.currentView.ready().done(() => {
      loader.hide();
    }).fail(() => {
      loader.hide();
      if (!this.getOption('hideErrors')) {
        const dialog = new svs.ui.dialog.Confirm({
          actions: [{
            callback: () => {
              dialog.close();
              svs.player_profile.router.navigate('/', true);
            },
            title: 'Ok'
          }],
          area: svs.ui.dialog.area.POPUP,
          branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
          message: [{
            text: 'Försök igen lite senare.'
          }],
          title: 'Något gick visst fel',
          type: svs.ui.dialog.type.ERROR
        });
        svs.ui.dialog.api.add(dialog);
      }
    });
  }
});

 })(window);